export default ['Saiba Mais', 'Autoavaliação', 'Plano de Desenvolvimento Pessoal', 'Diário de Bordo', 'Jornada'];
